








































import Vue from 'vue';
import Component from 'vue-class-component';
import {createHelpers} from 'vuex-map-fields';
import adaptiveButtonSize from '@/mixins/adaptiveButtonSize';

const { mapFields } = createHelpers({
  getterType: 'getUiField',
  mutationType: 'updateUiField',
});

@Component({
  computed: {...mapFields([
      'isDBPDisclamer'
    ]),
  },
  mixins: [adaptiveButtonSize]
})

export default class DBPDisclamer extends Vue {
  private isDBPDisclamer!: boolean;
  private confirmation: boolean = false;

  public closeModal() {
    this.isDBPDisclamer = false;
  }

  public accept() {
    this.isDBPDisclamer = false;
    this.$store.state.ui.acceptDBPDataPrivacyCallback();
    this.$store.state.ui.acceptDBPDataPrivacyCallback = () => null;
  }
}
